export function getArcGISAPIKey() {
  return process.env.REACT_APP_ARCGIS_API_KEY
}

export function getDisclaimer() {
  return window.env.REACT_APP_DISCLAIMER
}

export function getAnalyticsId() {
  return process.env.REACT_APP_ANALYTICS_ID
}

export function getApiUrl() {
  return window.env.REACT_APP_EGGSPEDITION_API_URL
}

/**
 * De basis-URL voor de `/ml/*`-endpoints (hertraining van het soortmodel).
 *
 * Normaal dezelfde API als de rest. `REACT_APP_ML_API_URL` bestaat alleen om tijdens de bouw tegen
 * de mock in `ui/mock/mlMockServer.js` te kunnen werken zonder de rest van de app om te leggen; op
 * test, acceptatie en productie hoort hij niet in `env.js` te staan.
 */
export function getMlApiUrl() {
  return window.env?.REACT_APP_ML_API_URL || getApiUrl()
}

/**
 * Of een hertraining echt in de wachtrij gaat.
 *
 * Het scherm laat al zien wat hertrainen wordt — wat er klaarstaat, de instellingen, de bevestiging —
 * maar de trainer zelf is nog niet af. Zolang deze vlag uit staat zegt "Start" dat het nog niet
 * beschikbaar is en gaat er niets naar de API. Aanzetten per omgeving met
 * `REACT_APP_ML_RETRAINING_ENABLED: true` in `env.js`.
 */
export function isMlRetrainingEnabled() {
  const value = window.env?.REACT_APP_ML_RETRAINING_ENABLED
  return value === true || value === "true"
}

export function getSupportEmail() {
  return window.env?.REACT_APP_SUPPORT_EMAIL || "ontwikkelaars@hkv.nl"
}

/**
 * Of deze omgeving uit de zoekresultaten moet blijven.
 *
 * Een testomgeving met dezelfde teksten als productie is voor een zoekmachine een tweede site met
 * dezelfde inhoud. Die kan de echte site verdringen of verdunnen, zeker op de merknaam. Zet
 * `REACT_APP_NOINDEX: true` in de `env.js` van elke omgeving die niet de echte site is.
 */
export function isNoIndex() {
  return window.env?.REACT_APP_NOINDEX === true || window.env?.REACT_APP_NOINDEX === "true"
}
